/**
 * V68/V69 조직관리 > 인력 관리 페이지 (탭 컨테이너)
 * V69: '프로젝트 인력 현황판' 탭을 1번 위치 + 기본 진입 탭으로 추가
 */
import React, { useState } from 'react';
import { ProjectWorkforceDashboardTab } from './components/ProjectWorkforceDashboardTab';
import { WorkforceAllocationTab } from './components/WorkforceAllocationTab';
import { IdleWorkforceTab } from './components/IdleWorkforceTab';
import { EmploymentTypeInfoTab } from './components/EmploymentTypeInfoTab';

type TabKey = 'projectDashboard' | 'allocation' | 'idle' | 'employmentType';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'projectDashboard', label: '프로젝트 인력 현황판' },
  { key: 'allocation', label: '인력투입 현황' },
  { key: 'idle', label: '유휴인력 관리' },
  { key: 'employmentType', label: '고용형태 정보' },
];

export function OrgWorkforceManagementPage() {
  const [active, setActive] = useState<TabKey>('projectDashboard');

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}>
        <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>인력 관리</h1>
        <p style={{ fontSize: 13, color: 'var(--color-gray-500)' }}>
          전사 직원의 월별 프로젝트 투입 현황과 유휴 인력을 관리합니다.
        </p>
      </div>

      <div style={{ display: 'flex', gap: 4, borderBottom: '2px solid var(--color-gray-200)', marginBottom: 16 }}>
        {TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setActive(t.key)}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderBottom: active === t.key ? '3px solid var(--color-primary)' : '3px solid transparent',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: active === t.key ? 600 : 500,
              color: active === t.key ? 'var(--color-primary)' : 'var(--color-gray-600)',
              marginBottom: '-2px',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {active === 'projectDashboard' && <ProjectWorkforceDashboardTab />}
      {active === 'allocation' && <WorkforceAllocationTab />}
      {active === 'idle' && <IdleWorkforceTab />}
      {active === 'employmentType' && <EmploymentTypeInfoTab />}
    </div>
  );
}
